import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
import { EntitySuggestionSchema } from '../../entities/entity-suggestion';
export const RejectEntitySuggestionRequestSchema = z.object({
    rejectionReason: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});
export const RejectEntitySuggestionResponseSchema = z.object({
    data: EntitySuggestionSchema
});

//# sourceMappingURL=reject-entity-suggestion.contract.js.map